import { Button, Container, Stack, Text, Title } from "@mantine/core";
import { IconError404 } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container size="xs" py={80}>
      <Stack align="center" gap="lg">
        <IconError404 size={120} stroke={1} color="var(--mantine-color-dimmed)" aria-hidden="true" />
        <Title order={1} ta="center">
          Page not found
        </Title>
        <Text c="dimmed" ta="center" maw={400}>
          The page you're looking for doesn't exist or has been moved.
        </Text>
        <Button size="md" onClick={() => navigate("/")}>
          Back to Feed
        </Button>
      </Stack>
    </Container>
  );
}
